<template>
  <div class="training-program">
    <SOSlotBase
      :container-name="`landing-page-belajar-bersama-smartlink`"
      :loading="isLoading"
    >
      <template v-slot:title-bar>
        <SOTitleBar
          :page-title="'Belajar Bersama Smartlink'"
          :type="'back'"
          @back="back"
        />
      </template>

      <template v-slot:content>
        <div class="p-x-20 remove-margin">
          <div class="d-flex-between remove-margin">
            <div class="f-14 f-regular f-c-primary p-y-16 remove-margin">
              <label class="m-d-0"> Training Saya </label>
              <div class="f-18 f-bold remove-margin">
                <b> Belum Ada Training </b>
              </div>

            </div>
            <button
              class="btn btn-outline-primary remove-margin"            >
              Riwayat Training
            </button>
          </div>


          <div class="separator m-x-min m-d-20" />
          <div class="m-x-min">
            <div class="p-x-20">
              <div class="f-18 f-bold">
                <p>Program yang Tersedia</p>
              </div>

              <div class="f-0 f-regular f-c-primary p-y-5">
                <label class="m-d-0">
                  Mulai pelajari aplikasi smartowner dengan memilih
                </label>
                <br />
                <label class="m-d-0"> program yang tersedia dibawah ini </label>
              </div>
            </div>
          </div>
          
          <template>
            <div class="card card-free">
              <div class="card-header">
                <b class="header-text">Training Free Online</b>
                <p class="price-text">Rp 0 /pertemuan</p>
              </div>
              <div class="card-body">
                <p>
                  Ketahui bagaimana cara mengoperasikan <br />
                  aplikasi smartlink sesuai standart manajemen operasional
                  outlet
                </p>
                <b class="sub-body"> Benefit Program</b>

                <ul class="list-text">
                  <li>Cocok untuk pemula yang baru mengenal smartlink</li>
                  <li>Durasi training 45 menit</li>
                  <li>
                    Dapatkan rekan baru sesama owner laundry dari berbagai
                    daerah
                  </li>
                </ul>
                <button
                  class="btndftr btn-primary"
                  @click="navigateToPilihProgram"
                >
                  Daftar
                </button>
              </div>
            </div>

            <div class="card card-paid-online">
              <div class="card-header">
                <div class="header-content">
                  <b class="header-text">Training Berbayar Online</b>
                  <p class="price-text">Rp 500 000 /2x Pertemuan</p>
                </div>
              </div>
              <div class="card-body">
                <p>
                  Ketahui bagaimana cara mengoperasikan <br />
                  aplikasi smartlink sesuai standart manajemen <br />
                  operasional hingga manajemen laporan owner
                </p>
                <b class="sub-body"> Benefit Program</b>

                <ul class="list-text">
                  <li>
                    Cocok bagi user yang ingin belajar lebih detail secara
                    keseluruhan mengenai aplikasi smartlink
                  </li>
                  <li>Durasi training kurang lebih 2 jam</li>
                  <li>Penjelasan semua fitur Smartlink</li>
                  <li>Paket All-In <b>Rp 500.000</b> untuk 2x pertemuan</li>
                </ul>
                <button
                  class="btndftr2 btn-primary"
                  @click="navigateToPilihProgramPO"
                >
                  Daftar
                </button>
              </div>
            </div>

            <div class="card card-offline-basic">
              <div class="card-header">
                <div class="header-content">
                  <div class="label">PALING POPULER</div>
                  <b class="header-text">Training Offline Basic</b>
                  <p class="price-text">Rp 1.500.000 /4 Jam</p>
                </div>
              </div>
              <div class="card-body">
                <p>
                  Pelajari semua fitur aplikasi kasirmudah dengan <br />
                  secara intens dengan panduan dari CS kami secara langsung.
                  <br />
                  Pilih Paket program yang tersedia untuk mendapatkan
                  benefitnya.
                </p>
                <b class="sub-body"> Benefit Program</b>

                <ul class="list-text">
                  <li>Sesi training tatap muka (Kunjungan Outlet)</li>
                  <li>
                    Penjelasan semua fitur Smartlink (Aplikasi Smartowner, Kasir
                    & Produksi)
                  </li>
                  <li>Biaya Konsultasi hanya <b>Rp 1.500.000</b></li>
                  <li>Sesi waktu training 4 jam/hari (dalam 2 hari)</li>
                </ul>
                <button
                  class="btndftr3 btn-primary"
                  @click="navigateToPilihProgramOB"
                >
                  Daftar
                </button>
              </div>
            </div>

            <div class="card card-offline-allin">
              <div class="card-header">
                <div class="header-content">
                  <b class="header-text">Training Offline All-In</b>
                  <p class="price-text">Rp 3.000.000 /4 Jam</p>
                </div>
              </div>
              <div class="card-body">
                <p>
                  Pelajari semua fitur aplikasi kasirmudah dengan <br />
                  secara intens dengan panduan dari CS kami secara langsung.
                  <br />
                  Pilih Paket program yang tersedia untuk mendapatkan
                  benefitnya.
                </p>
                <b class="sub-body"> Benefit Program</b>

                <ul class="list-text">
                  <li>Sesi training tatap muka (Kunjungan Outlet)</li>
                  <li>
                    Penjelasan semua fitur Smartlink (Aplikasi Smartowner, Kasir
                    & Produksi)
                  </li>
                  <li><b>Free Aktivasi Outlet</b></li>
                  <li><b>Free Printer 58 mm</b></li>
                  <li>Biaya Konsultasi hanya <b>Rp 3.000.000</b></li>
                  <li>Sesi waktu training 4 jam/hari (dalam 2 hari)</li>
                </ul>
                <button
                  class="btndftr4 btn-primary"
                  @click="navigateToPilihProgramOAI"
                >
                  Daftar
                </button>
              </div>
            </div>
          </template>
        </div>
      </template>
    </SOSlotBase>
  </div>
</template>

<script>
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOButton from "@/so-components/global/ui/SOButton";

export default {
  name: "Training",
  components: {
    SOSlotBase,
    SOTitleBar,
    SOButton,
  },

  data() {
    return {
      isLoading: false
    }
  },

  methods: {
    navigateToPilihProgram() {
      this.$router.push({ name: "pilihProgramFO" });
    },
    navigateToPilihProgramPO() {
      this.$router.push({ name: "pilihProgramPO" });
    },
    navigateToPilihProgramOB() {
      this.$router.push({ name: "pilihProgramOB" });
    },
    navigateToPilihProgramOAI() {
      this.$router.push({ name: "pilihProgramOAI" });
    },

    back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.training-program .separator {
  width: unset;
  height:15px;
}
.training-program .d-flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.text-container {
  display: flex;
}
.training-program  .text-container .epayment-container {
  width: 121px;
}
.training-program  .text-container .reminder-container {
  width: 71px;
}

.training-program .card {
  border-radius: 8px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin: 15px 0px;
}

.card-free {
  background: linear-gradient(
    154deg,
    #f2c94c 0%,
    rgba(252, 170, 73, 0.43) 100%
  );
}
.card-paid-online {
  background: linear-gradient(
    143deg,
    #2f957c 0%,
    rgba(76, 168, 135, 0.43) 100%
  );
}

.card-offline-basic {
  background: linear-gradient(
    143deg,
    #206cff 0%,
    rgba(52, 130, 202, 0.43) 100%
  );
  border-width: 3px;
  border-color: #206cff;
}

.card-offline-allin {
  background: linear-gradient(
    143deg,
    #7520ff 0%,
    rgba(181, 52, 202, 0.43) 100%
  );
}

.training-program .card-header {
  padding: 23px, 16px, 23px, 16px;
  gap: 8px;
  color: white;
}

.training-program .label {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 5px 6px;
  width: 150px;
  gap: 10px;
  margin-top: 15px;
  margin-bottom: 15px;
  background-color: #f2924c;
  color: white;
  font-weight: bold;
  text-transform: uppercase;
  border-radius: 4px;
  top: 10px;
  left: 10px;
}
.training-program .header-text {
  font-size: 1.5rem;
  margin: 0;
}

.training-program .price-text {
  font-size: 1.5rem;
  margin: 0;
}

.training-program .card-body {
  background-color: white;
  padding: 20px;
  text-align: start;
}

.training-program .sub-body {
  font-size: 1.2rem;
  margin: 0;
  text-decoration-style: solid;
}

.training-program .list-text {
  margin-top: 10px;
  padding-left: 20px;
}

.training-program .list-text li {
  margin-bottom: 8px;
  font-size: 1rem;
}

.training-program .btndftr {
  background-color: #f2c94c;
  color: white;
  border: none;
  border-radius: 3px;
  padding: 5px, 16px;
  width: calc(100% - 10px);
  height: 40px;
}

.training-program .btndftr2 {
  background-color: #30957d;
  color: white;
  border: none;
  border-radius: 3px;
  padding: 5px, 16px;
  width: calc(100% - 10px);
  height: 40px;
}

.training-program .btndftr3 {
  background-color: #206cff;
  color: white;
  border: none;
  border-radius: 3px;
  padding: 5px, 16px;
  width: calc(100% - 10px);
  height: 40px;
}

.training-program  .btndftr4 {
  background-color: #7521ff;
  color: white;
  border: none;
  border-radius: 3px;
  padding: 5px, 16px;
  width: calc(100% - 10px);
  height: 40px;
}

@media screen and (min-width: 800px) {
  .training-program .card {
    float: left !important;
    width: calc(50% - 50px) !important;
    margin-left: 25px !important;
    margin-right: 25px !important;
  }
}

</style>
